export { default } from './Inspiration';
